import React from 'react';
import needle_new from "../../../assets/svgs/treemeter/needle_new.svg";
import meter from "../../../assets/svgs/treemeter/meter3.svg";

import customCSS from './Treemeter.module.css'


export const Treemeter = ({  numberOfTrees  }) => {
  const imageContainerStyles = {
    position: "relative",
    width: "153px",
    height: "81px",
  };

  const needleStyles = {
    position: 'absolute',
    zIndex: "2",
    left: "23%",
    transformOrigin: "50% 80%",
    transition: "all 1s ease-in-out",
    bottom: "-6px",
  };

  const meterStyles = {
    // position: 'absolute',
    zIndex: "1",
  }

    // Convert the number of trees to degrees on the 180-degree scale.
  // If numberOfTrees is over 100, start from 0 degrees again.
  const treesToDegrees = (numberOfTrees % 101) * 1.8; // 180 degrees / 100 trees = 1.8 degrees per tree
  
  return (
    <div className={customCSS.container}>
      <div style={imageContainerStyles}>
        <img
          src={needle_new}
          style={{ ...needleStyles, transform: `rotateZ(${treesToDegrees - 90}deg)` }}
        />
        <img src={meter} style={meterStyles} />
      </div>
    </div>
  );
};